import {
  handleDeleteForum,
  handleRetrieveAllForums,
} from "../../../redux/user-slices/forum.slice.js";
import { checkUserType, FILE_PATH_URI } from "../../../utils/helper.js";
import { refresher } from "../../../redux/guest-slices/other.slice.js";
import { useDispatch, useSelector } from "react-redux";
import SkeletonImage from "../../ui/SkeletonImage.jsx";
import { Link as NavLink } from "react-router-dom";
import Icons from "../../../assets/js/Icons.js";
import { useEffect, useState } from "react";
import moment from "moment";

import {
  Alert,
  Box,
  Divider,
  Grid2 as Grid,
  IconButton,
  Link,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import ShareDialog from "../../common/dialogs/ShareDialog.jsx";

function AllForum() {
  const dispatch = useDispatch();
  const userType = checkUserType();
  const [data, setdata] = useState({});
  const { loadings, refresh } = useSelector((state) => state.otherSlice);
  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [selectedForumData, setSelectedForumData] = useState(null);
  // Handle retrieve all forums
  const handleretrieveAll = async () => {
    const response = await dispatch(
      handleRetrieveAllForums({
        limit: 100,
      })
    ).unwrap();
    setdata(response);
  };

  // Handle delete forum
  const handleDelete = async (forumId) => {
    await dispatch(handleDeleteForum(forumId)).unwrap();
    dispatch(refresher());
  };

  const handleShareClick = (forumData) => {
    setSelectedForumData(forumData);
    setShareDialogOpen(true);
  };

  // Handle share dialog close
  const handleShareDialogClose = () => {
    setShareDialogOpen(false);
    setSelectedForumData(null);
  };
  useEffect(() => {
    handleretrieveAll();

    // eslint-disable-next-line
  }, [refresh]);

  return (
    <Box
      sx={{
        p: 3,
        height: "100%",
        bgcolor: "white",
        borderRadius: "8px",
      }}
    >
      <Grid container spacing={2}>
        {loadings?.retrieveAll ? (
          new Array(4).fill().map((_, i) => (
            <Grid key={i} size={{ xs: 12, md: 6, xl: 4 }}>
              <Skeleton
                sx={{
                  width: "100%",
                  height: "100%",
                  transform: "none",
                  aspectRatio: "1/0.5",
                }}
              />
            </Grid>
          ))
        ) : data?.records?.length === 0 ? (
          <Grid size={12}>
            <Alert
              sx={{
                fontSize: "20px",
                fontWeight: "500",
                alignItems: "center",
                fontFamily: "Poppins",
                ".MuiAlert-message": { p: "0" },
                ".MuiAlert-icon": { fontSize: "28px" },
              }}
              color="error"
              severity="error"
            >
              No Records Found!
            </Alert>
          </Grid>
        ) : (
          data?.records?.map((element, i) => (
            <Grid key={i} size={{ xs: 12, md: 6, xl: 4 }}>
              <Paper
                sx={{
                  p: 2,
                  gap: 1,
                  height: "100%",
                  display: "flex",
                  borderRadius: "6px",
                  border: "1px solid",
                  borderColor: "divider",
                  flexDirection: "column",
                  transition: "all 450ms ease",
                  boxShadow: "0 0 10px 0 #0000000a",
                  ":hover": {
                    transform: "scale(1.01)",
                    boxShadow: "0 0 10px 0 #00000021",
                  },
                }}
              >
                <Box
                  sx={{
                    gap: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography
                    lineHeight="1"
                    fontWeight="400"
                    component="span"
                    color="other.color2"
                    mt="auto !important"
                  >
                    {moment(element?.createdAt).format("MMM DD YYYY")}
                  </Typography>
                  <Stack spacing={0.5} direction="row">
                    <IconButton
                      size="small"
                      LinkComponent={NavLink}
                      to={`/${userType}/profile/edit-forum/${element?._id}`}
                    >
                      <Icons.EditSolid />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => {
                        handleDelete(element?._id);
                      }}
                    >
                      <Icons.DeleteSolid />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => handleShareClick(element)}
                    >
                      <Icons.ShareSolid />
                    </IconButton>
                  </Stack>
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    maxHeight: "200px",
                    overflow: "hidden",
                    borderRadius: "6px",
                    aspectRatio: "1/0.6",
                  }}
                >
                  <SkeletonImage src={FILE_PATH_URI + element?.banner?.path} />
                </Box>

                <Stack spacing={1} sx={{ flexGrow: 1 }}>
                  <Divider />
                  <Link
                    sx={{
                      width: "100%",
                      overflow: "hidden",
                      WebkitLineClamp: 1,
                      color: "other.color1",
                      display: "-webkit-box",
                      WebkitBoxOrient: "vertical",
                      transition: "all 350ms ease",
                      ":hover": {
                        color: "primary.main",
                      },
                    }}
                    fontSize={20}
                    fontWeight="500"
                    underline="hover"
                    component={NavLink}
                    to={`/forum/${element?._id}`}
                  >
                    {element?.title}
                  </Link>
                  <Box
                    sx={{
                      overflow: "hidden",
                      WebkitLineClamp: "2",
                      display: "-webkit-box",
                      textOverflow: "ellipsis",
                      WebkitBoxOrient: "vertical",
                    }}
                    dangerouslySetInnerHTML={{ __html: element?.description }}
                  />
                </Stack>
              </Paper>
            </Grid>
          ))
        )}
      </Grid>
      <ShareDialog
        open={shareDialogOpen}
        onClose={handleShareDialogClose}
        forumData={selectedForumData}
      />
    </Box>
  );
}

export default AllForum;
